/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Paused/view.blocks to change it.
import React from 'react'
import ResumeAction from './ResumeAction/index'
import StopAction from './StopAction/index'



/** @type {import('Simple/types.js').View} */
export default function Paused({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Paused"
  
}) {
  return (<React.Fragment
>
<ResumeAction
  viewPath={`${viewPath}/ResumeAction`}
/>
<StopAction
  viewPath={`${viewPath}/StopAction`}
/>
{children}
</React.Fragment>)
}